import AxiosConfig from '../../../../../../config/AxiosConfig';

export const isButtonDisplayed = ({ order }) => {
  if (!order) {
    return false;
  }
  const { type } = order;

  if (type?.code === 'ORDER_SAV') {
    return false;
  }

  return true;
};

export const isSCButtonDisplayed = ({ order }) => {
  if (!order) {
    return false;
  }

  return (
    order?.status?.code === 'VALIDATED' || order?.status?.code === 'WAITING_SC'
  );
};

export const isWaitSCAuthorized = (order) => {
  if (order?.status?.code === 'WAITING_SC') {
    return false;
  }
  if (order?.type?.code === 'ORDER_SAV') {
    const statuses = ['FREE', 'CAPTURED'];
    return !statuses?.includes(order?.paymentStatus?.code);
  } else if (order?.status?.code === 'VALIDATED') {
    return order?.paymentStatus?.code !== 'CAPTURED';
  }
  return true;
};

export const getFormattedNote = (
  name,
  noteContent,
  value,
  formatType,
  stateToLock
) => {
  const titles = {
    status: `Mise à jour de la commande au statut "${value}"`,
    shippingDate: `Mise à jour de la date d'expédition souhaitée au "${value}"`,
    shippingAddress: `Mise à jour de l'adresse de livraison: Nouvelle adresse: ${value}`,
    retractConfirm: 'Confirmation de la rétractation',
    retractUpdate: 'Mise à jour des informations de transport',
  };

  return `
==> ${titles[formatType]}
==> Modifié par : ${name}
==> Commentaire : ${noteContent || 'Aucun commentaire fourni'}
${stateToLock ? '==> Statut de commande verrouillé' : ''}
`;
};

export const handleCancelOrderDraft = async ({ ticket }) => {
  try {
    // Delete existing attachments if any
    if (ticket?.draft?.attachments?.length > 0) {
      const deletePromises = ticket.draft.attachments.map((attachment) =>
        AxiosConfig.create(
          'delete',
          `/messages/${ticket.draft._id}/attachments/${attachment._id}`
        ).call()
      );

      await Promise.all(deletePromises);
    }

    // Update existing draft with empty content
    const updatedDraftData = {
      ticketId: ticket?._id,
      to: ticket?.order?.contact?.email,
      from: ticket?.draft?.from,
      subject: ticket?.order?.reference,
      content: '',
      receivers: [ticket?.order?.contact?.email],
      attachments: [],
    };

    await AxiosConfig.create('put', `/messages/${ticket?.draft?._id}/save`)
      .call(updatedDraftData)
      .exit((res) => {
        console.log('Draft mis à jour avec succès');
        return res.data;
      });
  } catch (error) {
    console.error('Erreur dans handleCancelOrderDraft:', error);
    throw error;
  }
};

export const cancelOrderTemplate = ({ firstName, lastName, amount, image }) => {
  const template = {
    type: 'doc',
    content: [
      {
        type: 'paragraph',
        attrs: {
          textAlign: 'left',
        },
        content: [
          {
            type: 'text',
            text: `Bonjour${firstName ? ` ${firstName}` : ''}${lastName ? ` ${lastName}` : ''},`,
          },
        ],
      },
      {
        type: 'paragraph',
        attrs: {
          textAlign: 'left',
        },
      },
      {
        type: 'paragraph',
        attrs: {
          textAlign: 'left',
        },
        content: [
          {
            type: 'text',
            text: 'Nous vous remercions pour votre message.',
          },
        ],
      },
      {
        type: 'paragraph',
        attrs: {
          textAlign: 'left',
        },
        content: [
          {
            type: 'text',
            text: "Nous vous confirmons avoir procédé à l'annulation de votre commande ce jour.",
          },
        ],
      },
      {
        type: 'paragraph',
        attrs: {
          textAlign: 'left',
        },
        content: [
          {
            type: 'text',
            text: `Nous allons procéder au remboursement intégral de votre commande d'un montant de ${amount}.`,
          },
        ],
      },
      {
        type: 'paragraph',
        attrs: {
          textAlign: 'left',
        },
        content: [
          {
            type: 'text',
            text: "Votre remboursement sera effectif sous huitaine, sur le moyen de paiement utilisé à l'achat.",
          },
        ],
      },
      {
        type: 'paragraph',
        attrs: {
          textAlign: 'left',
        },
        content: [
          {
            type: 'text',
            text: "Nous restons à votre disposition pour tout complément d'information,",
          },
        ],
      },
      {
        type: 'paragraph',
        attrs: {
          textAlign: 'left',
        },
      },
      {
        type: 'paragraph',
        attrs: {
          textAlign: 'left',
        },
        content: [
          {
            type: 'text',
            text: 'Bien cordialement,',
          },
        ],
      },
      {
        type: 'paragraph',
        attrs: {
          textAlign: 'left',
        },
        content: [
          {
            type: 'text',
            text: "L'équipe Logistique d'Hoortrade,",
          },
        ],
      },
      ...(image
        ? [
            {
              type: 'paragraph',
              attrs: {
                textAlign: 'center',
              },
              content: [
                {
                  type: 'image',
                  attrs: {
                    src: image,
                    alt: 'Logo Hoortrade',
                    title: 'Hoortrade',
                    width: 200,
                  },
                },
              ],
            },
          ]
        : []),
    ],
  };

  return template;
};

export const hasValidChars = (string) => {
  // Caractères spéciaux à ignorer (codes Unicode)
  const ignoredCharsCodes = [
    8211, // – (tiret cadratin)
    8216, // ' (guillemet simple gauche)
    8217, // ' (guillemet simple droit)
    8220, // " (guillemet double gauche)
    8221, // " (guillemet double droit)
    8304, // ⁰ (exposant zéro)
    8453, // ℅ (symbole care of)
  ];

  // Test si tous les caractères sont ASCII (codes ≤ 255)
  if ([...string].every((char) => char.charCodeAt(0) <= 255)) {
    return true;
  }

  // Extraction des caractères non-ASCII
  // eslint-disable-next-line no-control-regex
  const asciiChars = string.normalize('NFKD').replace(/[^\x00-\xFF]/g, '');

  let nonAsciiChars = string;

  // Suppression des caractères ASCII
  [...asciiChars].forEach((char) => {
    nonAsciiChars = nonAsciiChars.replace(char, '');
  });

  // Suppression des caractères ignorés
  [...nonAsciiChars].forEach((char) => {
    const code = char.charCodeAt(0);
    if (code <= 255 || ignoredCharsCodes.includes(code)) {
      nonAsciiChars = nonAsciiChars.replace(char, '');
    }
  });

  // Vérification des caractères restants
  return [...nonAsciiChars].every((char) => {
    // Conversion en représentation Unicode
    const unicodeName = char
      .normalize('NFKD')
      .split('')
      .map((c) => `\\u${c.charCodeAt(0).toString(16).padStart(4, '0')}`)
      .join('');

    return unicodeName.includes('LATIN');
  });
};

export const isDelayOverDue = (date, type, duration) => {
  const today = new Date();
  const time = new Date(date);

  switch (type) {
    case 'day':
      today.setDate(today.getDate() - duration);
      break;
    case 'month':
      today.setMonth(today.getMonth() - duration);
      break;
    case 'year':
      today.setFullYear(today.getFullYear() - duration);
      break;
    default:
      break;
  }
  if (today.getTime() > time.getTime()) {
    return true;
  }
  return false;
};

export const resetFormAndErrors = ({
  setFormData,
  setFormError,
  orderDetails,
  user,
  // delayOverDue,
}) => {
  setFormData({
    isDraft: false,
    activeSavDraftId: null,
    savDraftReference: '',
    customerOrder: orderDetails.reference,
    ticket: orderDetails?.ticket?.reference,
    amountTtcNet: 100,
    lines: [],
    shippingAddress: {},
    billingAddress: {},
    // TODO: set payable to delayOverDue when sav payable is implemented
    isPayable: false,
    paymentMethod: orderDetails?.paymentMethod,
    createdBy: user?.email,
    reason: '',
    currency: orderDetails?.currency.code,
    isSet: false,
    isDraftSet: false,
    lastName: orderDetails?.contact?.lastName,
    firstName: orderDetails?.contact?.firstName,
    phone: orderDetails?.contact?.phone,
    comment: '',
    orderPicker: '',
    desiredShippingDate: null,
    updatedAt: '',
  });
  setFormError({
    savDraftReference: '',
    isPayable: '',
    customerOrder: '',
    lines: '',
    reason: '',
    comment: '',
    orderPicker: '',
    desiredShippingDate: '',
    amountTtcNet: '',
    shippingAddress: {
      address1: '',
      address2: '',
      postalCode: '',
      city: '',
      country: '',
    },
    billingAddress: {
      address1: '',
      address2: '',
      postalCode: '',
      city: '',
      country: '',
    },
  });
};
